import template from './fullscreen.html';
import Kiwi from '../kiwi/kiwi-service';

export default {
	name: 'Fullscreen',
	template,
	created () {
		this.url = this.$route.params.url;
	},
	data () {
		return {
			url: ''
		};
	},
	methods: {
		onEnd () {
			Kiwi.hideVideo('display2.euronics');
		}
	}
};



// WEBPACK FOOTER //
// ./src/fullscreen/fullscreen.js